"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeepMemo = void 0;
var dequal_1 = require("dequal");
var react_1 = require("react");
function useDeepMemo(memoFnOrValue, key) {
    var ref = react_1.useRef();
    if (isMemoFn(memoFnOrValue, key)) {
        if (!ref.current || !dequal_1.dequal(key, ref.current.key)) {
            ref.current = { value: memoFnOrValue(), key: key };
        }
    }
    else if (!ref.current || !dequal_1.dequal(memoFnOrValue, ref.current.value)) {
        ref.current = { value: memoFnOrValue };
    }
    return ref.current.value;
}
exports.useDeepMemo = useDeepMemo;
function isMemoFn(memoFnOrValue, key) {
    return typeof memoFnOrValue === 'function' && typeof key !== 'undefined';
}
exports.default = useDeepMemo;
//# sourceMappingURL=useDeepMemo.js.map